import { render, staticRenderFns } from "./fiscal.vue?vue&type=template&id=112aff48&scoped=true&"
import script from "./fiscal.vue?vue&type=script&lang=js&"
export * from "./fiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112aff48",
  null
  
)

export default component.exports